"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TIME = exports.DEFAULT_DELAY = exports.CONFETTI_COLORS = exports.CONFETTI_ANIMATIONS = void 0;
var CONFETTI_COLORS = ['#fce18a', '#ff726d', '#b48def', '#f4306d', '#ff8033', '#ffffff', '#4bae45'];
exports.CONFETTI_COLORS = CONFETTI_COLORS;
var CONFETTI_ANIMATIONS = ['slow', 'medium', 'fast'];
exports.CONFETTI_ANIMATIONS = CONFETTI_ANIMATIONS;
var DEFAULT_DELAY = '0';
exports.DEFAULT_DELAY = DEFAULT_DELAY;
var DEFAULT_TIME = '5000';
exports.DEFAULT_TIME = DEFAULT_TIME;